import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImac: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="imac, computer" maskId="round-filled-radius-0-stroke-1.5-IconImac"><path d="M2.75 3C2.33579 3 2 3.33579 2 3.75V12.5H22V3.75C22 3.33579 21.6642 3 21.25 3H2.75Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M2 17.25V14H22V17.25C22 17.6642 21.6642 18 21.25 18H15V21.25C15 21.6642 14.6642 22 14.25 22H9.75C9.33579 22 9 21.6642 9 21.25V18H2.75C2.33579 18 2 17.6642 2 17.25ZM10.5 18V20.5H13.5V18H10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImac;
